
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:block;
}

  :host :is(h1, h2, h3, h4, h5, h6, p){
    all:unset;
  }

  :host{
  --sic-body-text--font-size:var(--body-03-font-size);
  --sic-body-text--line-height:var(--body-03-line-height);
}
.content{
  padding-bottom:var(--sic-video--default--cta-spacing);
  padding-bottom:var(
    --sic-video--cta-spacing,
    var(--sic-video--default--cta-spacing)
  );
}
.description{
  padding-block-start:var(--sic-video--default--description-spacing);
  padding-block-start:var(
    --sic-video--description-spacing,
    var(--sic-video--default--description-spacing)
  );
  font-size:var(--sic-video--default--description-font-size);
  font-size:var(
    --sic-video--description-font-size,
    var(--sic-video--default--description-font-size)
  );
}
.cta{
  padding-block-start:var(--sic-video--default--cta-spacing);
  padding-block-start:var(
    --sic-video--cta-spacing,
    var(--sic-video--default--cta-spacing)
  );
}
@media (min-width: 1024px){
  .container--side-by-side{
    display:grid;
    align-items:center;
    grid-template-columns:repeat(2, 1fr);
    grid-template-rows:1fr;
    grid-column-gap:var(--spacing-12);
    grid-row-gap:0px;
  }

    .container--side-by-side .video-wrapper{
      padding-block-start:0;
    }
}
`;